if (!window.Eurus.loadedScript.has('variant-select-card.js')) {
  window.Eurus.loadedScript.add('variant-select-card.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xVariantSelectCard', (
        element,
        sectionId,
        productId,
        productUrl,
        customizableChooseOption,
        chooseOption,
        productBundle,
        pageParam,
        chooseOptionLabel,
        addToCartLabel,
        blockId,
        handleSectionId
      ) => ({
        loadingEls: '',
        currentVariant: {},
        cachedResults: [],
        init() {
		// START Selected unavailable size styling 2026-07-14
          Array.from(element.querySelectorAll('select')).forEach((select) => {
            this._bindUnavailableSelectStyle(select);
          });
          // END Selected unavailable size styling 2026-07-14
          // TWD CLEARANCE VARIANT FILTER - 2026-09-04
          // Collection cards carry the exact variant IDs that are allowed in the
          // current collection. Keep Color/Size controls inside that variant set.
          this.$nextTick(() => {
            this._coerceSelectionToAllowedVariant();
            this._applyClearanceVariantFilter();
          });
          // END TWD CLEARANCE VARIANT FILTER - 2026-09-04
          document.addEventListener(`eurus:product-card:clear:${productId}`, () => { 
            this._reloadCardProduct();
          })
          // TWD CARD HISTORY STATE SYNC - 2026-08-04
          // Browsers restore checked controls from the back/forward cache but do
          // not rerun the variant response renderer. Rebuild the visible label
          // and current variant from those restored controls.
          if (!chooseOption && !customizableChooseOption && !productBundle) {
            this.$nextTick(() => this._syncCardStateFromControls());
            window.addEventListener('pageshow', () => {
              requestAnimationFrame(() => this._syncCardStateFromControls());
            });
          }
        },
		// TWD CARD HISTORY STATE SYNC - 2026-08-04
        _syncCardStateFromControls() {
          const selectedValues = [];

          element.querySelectorAll('select, fieldset').forEach((control) => {
            const selected = control.tagName === 'SELECT'
              ? control.selectedOptions?.[0]
              : control.querySelector('input:checked');
            if (selected?.value) selectedValues.push(selected.value);

            const label = control.querySelector?.('.option-selected-value');
            const valueTarget = label?.querySelector('span');
            if (valueTarget && selected?.value) {
              label.classList.remove('hidden');
              valueTarget.textContent = selected.value;
            }
          });

          if (!selectedValues.length) return;

          const variants = Array.from(
            element.querySelectorAll('script[type="application/json"][data-option-value-id]')
          ).map((script) => {
            try {
              return JSON.parse(script.textContent);
            } catch (_) {
              return null;
            }
          }).filter(Boolean);
          const restoredVariant = variants.find((variant) =>
            variant.options?.length === selectedValues.length
            && variant.options.every((value, index) => value === selectedValues[index])
          );
          if (!restoredVariant?.id) return;

          const cardProduct = element.closest('.card-product');
          const currentVariant = element.querySelector('.current-variant');
          if (currentVariant) currentVariant.textContent = restoredVariant.id;
          cardProduct?.querySelectorAll('form input[name="id"]').forEach((input) => {
            input.value = restoredVariant.id;
          });
          this.currentVariant = restoredVariant;
        },
 		// START Selected unavailable size styling 2026-07-14
        // TWD SIZE DROPDOWN WRAPPERS - REFACTORED 2026-07-29
        _bindUnavailableSelectStyle(select) {
          window.TWDSizeDropdown?.bind(select);
        },
        _syncUnavailableSelectStyle(select, showSelected = true) {
          window.TWDSizeDropdown?.sync(select, showSelected);
        },
        // END Selected unavailable size styling 2026-07-14
        // TWD CLEARANCE VARIANT FILTER - 2026-09-04
        _clearanceFilterEnabled() {
          // TWD CHOOSE OPTION - 2026-09-06
          // is_clearance_item filtering is collection-card visibility logic only.
          // Never disable/hide product colors or sizes inside Choose Option.
          if (chooseOption || element.closest('.choose-options')) return false;

          return element.dataset.clearanceFilterEnabled === 'true'
            && Boolean(element.dataset.clearanceAllowedVariantIds);
        },
        _getClearanceAllowedVariantIds() {
          if (!this._clearanceFilterEnabled()) return new Set();
          return new Set(
            element.dataset.clearanceAllowedVariantIds
              .split('||')
              .map((value) => value.trim())
              .filter(Boolean)
          );
        },
        _getClearanceVariants() {
          if (!this._clearanceFilterEnabled()) return [];
          const variantsJson = element.querySelector(
            'script[type="application/json"][data-product-variants]'
          )?.textContent?.trim();
          if (!variantsJson) return [];

          try {
            return JSON.parse(variantsJson);
          } catch (error) {
            console.error('Unable to parse clearance variant data.', error);
            return [];
          }
        },
        _getClearanceAllowedVariants() {
          const allowedIds = this._getClearanceAllowedVariantIds();
          if (!allowedIds.size) return [];
          return this._getClearanceVariants().filter((variant) =>
            allowedIds.has(String(variant.id))
          );
        },
        _getOptionControls() {
          return Array.from(element.querySelectorAll('select, fieldset'));
        },
        _getSelectedOptionTextValues() {
          return this._getOptionControls().map((control) => {
            const selected = control.tagName === 'SELECT'
              ? control.selectedOptions?.[0]
              : control.querySelector('input:checked');
            return selected?.value || '';
          });
        },
        _setControlsToVariant(variant) {
          if (!variant?.options?.length) return;
          this._getOptionControls().forEach((control, index) => {
            const targetValue = variant.options[index];
            if (targetValue == null) return;

            if (control.tagName === 'SELECT') {
              Array.from(control.options).forEach((option) => {
                const selected = option.value === targetValue;
                option.selected = selected;
                option.toggleAttribute('selected', selected);
              });
              this._syncUnavailableSelectStyle(control);
              return;
            }

            control.querySelectorAll('input').forEach((input) => {
              const checked = input.value === targetValue;
              input.checked = checked;
              input.toggleAttribute('checked', checked);
            });
          });
        },
        _coerceSelectionToAllowedVariant() {
          if (!this._clearanceFilterEnabled()) return null;
          const allowedVariants = this._getClearanceAllowedVariants();
          if (!allowedVariants.length) return null;

          const selectedValues = this._getSelectedOptionTextValues();
          const exactVariant = allowedVariants.find((variant) =>
            variant.options?.length === selectedValues.length
            && variant.options.every((value, index) => !selectedValues[index] || value === selectedValues[index])
          );
          if (exactVariant) return exactVariant;

          const colorPosition = Number(element.dataset.clearanceColorOptionPosition || 0);
          const colorIndex = colorPosition > 0 ? colorPosition - 1 : -1;
          const selectedColor = colorIndex >= 0 ? selectedValues[colorIndex] : '';
          let candidates = allowedVariants;

          if (selectedColor) {
            const colorCandidates = allowedVariants.filter((variant) =>
              variant.options?.[colorIndex] === selectedColor
            );
            if (colorCandidates.length) candidates = colorCandidates;
          }

          // Prefer the candidate that preserves the most currently selected values,
          // then prefer an available variant. This mainly changes Size when a color
          // switch would otherwise land on a clearance-hidden size.
          candidates = [...candidates].sort((a, b) => {
            const score = (variant) => variant.options.reduce((total, value, index) =>
              total + (selectedValues[index] && selectedValues[index] === value ? 1 : 0), 0);
            const scoreDiff = score(b) - score(a);
            if (scoreDiff) return scoreDiff;
            return Number(Boolean(b.available)) - Number(Boolean(a.available));
          });

          const fallbackVariant = candidates[0];
          if (fallbackVariant) this._setControlsToVariant(fallbackVariant);
          return fallbackVariant || null;
        },
        _setClearanceEntryVisibility(control, entry, visible) {
          if (control.tagName === 'SELECT') {
            entry.hidden = !visible;
            entry.disabled = !visible;
            entry.dataset.twdClearanceHidden = visible ? 'false' : 'true';
            return;
          }

          entry.disabled = !visible;
          entry.dataset.twdClearanceHidden = visible ? 'false' : 'true';
          const label = entry.id
            ? control.querySelector(`label[for="${CSS.escape(entry.id)}"]`)
            : null;
          if (label) label.hidden = !visible;

          // Most card button/swatches wrap input + label in one relative inline-flex div.
          const wrapper = entry.parentElement;
          if (wrapper && wrapper !== control && wrapper.querySelector('label')) {
            wrapper.hidden = !visible;
          }
        },
        _applyClearanceVariantFilter() {
          if (!this._clearanceFilterEnabled()) return;
          const allowedVariants = this._getClearanceAllowedVariants();
          if (!allowedVariants.length) return;

          const controls = this._getOptionControls();
          const selectedValues = this._getSelectedOptionTextValues();
          const colorPosition = Number(element.dataset.clearanceColorOptionPosition || 0);
          const colorIndex = colorPosition > 0 ? colorPosition - 1 : -1;
          const selectedColor = colorIndex >= 0 ? selectedValues[colorIndex] : '';

          controls.forEach((control, optionIndex) => {
            const entries = control.tagName === 'SELECT'
              ? Array.from(control.options).filter((option) => option.value)
              : Array.from(control.querySelectorAll('input[value]'));

            entries.forEach((entry) => {
              const entryValue = entry.value;
              const visible = allowedVariants.some((variant) => {
                if (!variant.options || variant.options[optionIndex] !== entryValue) return false;

                // A color remains visible when ANY allowed variant exists for that
                // color. Size/other options are evaluated within the selected color.
                if (optionIndex === colorIndex) return true;
                if (colorIndex >= 0 && selectedColor && variant.options[colorIndex] !== selectedColor) return false;

                return controls.every((otherControl, otherIndex) => {
                  if (otherIndex === optionIndex || otherIndex === colorIndex) return true;
                  const selectedValue = selectedValues[otherIndex];
                  return !selectedValue || variant.options[otherIndex] === selectedValue;
                });
              });

              this._setClearanceEntryVisibility(control, entry, visible);
            });

            if (control.tagName === 'SELECT') this._syncUnavailableSelectStyle(control);
          });
        },
        // END TWD CLEARANCE VARIANT FILTER - 2026-09-04
        // TWD CARD LOADING RESET GUARD - 2026-07-30
        _scheduleLoadingReset(delay = 250) {
          if (this._loadingResetTimer) clearTimeout(this._loadingResetTimer);
          this._loadingResetTimer = setTimeout(() => {
            this.loadingEls = '';
            this._loadingResetTimer = null;
          }, delay);
        },
        _dispatchUpdateVariant(html="") {
          this._scheduleLoadingReset(100);
          document.dispatchEvent(new CustomEvent(`eurus:product-card-variant-select:updated:${sectionId}:${productUrl}`, {
            detail: {
              currentVariant: this.currentVariant,
              html: html
            }
          }));
        },
        _renderCardProductFormInput(formSrc, formDes) {
          const desInput = formDes.querySelectorAll('input');
          desInput?.forEach((input) => {
            if (input.name !== 'section-id' && input.name) {
              const src = formSrc.querySelector(`input[name=${CSS.escape(input.name)}]`);
              if (src) {
                input.value = src.value;
                input.checked = src.checked;
                input.disabled = src.disabled;
              }
            }
          });
        },
        _renderCardProductFormButton(formSrc, formDes) {
          const srcButton = formSrc.querySelector(`button`);
          if (srcButton) {
            const srcButtonText = srcButton.querySelector('.button-text');
            
            const desButton = formDes.querySelectorAll('button[type="submit"]');
            desButton.forEach((button) => {
              button.disabled = srcButton.disabled;
              button.ariaLabel = srcButton.ariaLabel;

              const desButtonText = button.querySelector('.button-text');
              if (srcButtonText.textContent.trim() == chooseOptionLabel) {
                srcButtonText.textContent = addToCartLabel;
              }
              if (desButtonText && srcButtonText) {
                desButtonText.innerHTML = srcButtonText.innerHTML;
              }
            });
          }
        },
        _renderCardProductForm(html) {
          let target = chooseOption ? '.choose-options' : '.card-product'

          const formSrc = html.querySelector('form[id*="product-form-"]');
          let formDesAll = element.closest(target)?.querySelectorAll('form[id*="product-form-"]');
          if (formSrc && formDesAll) { 
            formDesAll.forEach(formDes => {
              this._renderCardProductFormInput(formSrc, formDes);
              this._renderCardProductFormButton(formSrc, formDes);
            });
          }
        },
        _renderCardProductCurrentVariant(optionSrc, optionDes) {
          const currentVariantSrc = optionSrc.querySelector('.current-variant');
          const currentVariantDes = optionDes.querySelector('.current-variant');

          if (currentVariantSrc && currentVariantDes) {
            currentVariantDes.innerHTML = currentVariantSrc.innerHTML;
          }
        },
        _renderCardProductInputs(optionSrc, optionDes) {
          const inputsSrc = optionSrc.querySelectorAll('input');
          const inputsDes = optionDes.querySelectorAll('input');

          inputsDes?.forEach(des => {
            const src = Array.from(inputsSrc).find((inputSrc) => inputSrc.dataset.optionValueId === des.dataset.optionValueId);
            if (src && des) {
              if (src.classList.contains('disabled')) {
                des.classList.add('disabled');
              } else {
                des.classList.remove('disabled');
              }
              des.checked = src.checked;
              des.dataset.available = src.dataset.available;
            }
          });
        },
        _renderCardProductOptions(optionSrc, optionDes) {
          const optionsSrc = optionSrc.querySelectorAll('option');
          const optionsDes = optionDes.querySelectorAll('option');

          optionsDes?.forEach(des => {
            const src = Array.from(optionsSrc).find((optionSrc) => optionSrc.dataset.optionValueId === des.dataset.optionValueId);
            if (src && des) {
              // START Unavailable size styling 2026-07-14
              window.TWDSizeDropdown?.copyOptionState(des, src);
              // END Unavailable size styling 2026-07-14
            }
          });
        },
        _renderCardProductInputLabels(optionSrc, optionDes) {
          const labelsSrc = optionSrc.querySelectorAll('label');
          const labelsDes = optionDes.querySelectorAll('label');

          labelsDes?.forEach(des => {
            const src = Array.from(labelsSrc).find((labelSrc) => labelSrc.dataset.optionValueId === des.dataset.optionValueId);
            if (src) {
              if (des.style.getPropertyValue('--bg-image').trim() !== '') {
                des.style.setProperty('--bg-image', src.style.getPropertyValue('--bg-image'));
              }
              if (des.style.getPropertyValue('--ratio-image').trim() !== '') {
                des.style.setProperty('--ratio-image', src.style.getPropertyValue('--ratio-image'));
              }
            }
          });
        },
        _renderCardProductValueVariant(optionSrc, optionDes) {
          const scriptsSrc = optionSrc.querySelectorAll('script[type="application/json"][data-option-value-id]');
          const scriptsDes = optionDes.querySelectorAll('script[type="application/json"][data-option-value-id]');

          scriptsDes?.forEach(des => {
            const src = Array.from(scriptsSrc).find((scriptSrc) => scriptSrc.dataset.optionValueId === des.dataset.optionValueId);
            if (src && des) {
              des.textContent = src.textContent;
            }
          })
        },
        _renderCardProductOption(html) {
          const optionSrc = html.querySelector('.x-variants-data-js');
          const optionDes = element.closest('.x-variants-data-js');

          if (optionSrc && optionDes) {
            this._renderCardProductCurrentVariant(optionSrc, optionDes);
            this._renderCardProductInputs(optionSrc, optionDes);
            this._renderCardProductOptions(optionSrc, optionDes);
            this._renderCardProductInputLabels(optionSrc, optionDes);
            this._renderCardProductValueVariant(optionSrc, optionDes);
            this._coerceSelectionToAllowedVariant();
            this._applyClearanceVariantFilter();
          }
        },
        _renderCardProductPrice(html) {
          // START Choose Option exact variant price 2026-07-21
          // Variant requests return the card-product section, whose dedicated
          // choose-option-price block contains the exact selected variant price.
          if (chooseOption) {
            const priceSrc = html.querySelector('.x-card-price .choose-option-price');
            const priceDes = element.closest('.choose-options')
              ?.querySelector(`#price-${CSS.escape(sectionId)}`);
            if (!this.currentVariant?.id || !priceSrc || !priceDes) return;

            priceDes.classList.remove('hidden');
            priceDes.innerHTML = priceSrc.innerHTML;
            return;
          }
          // END Choose Option exact variant price 2026-07-21

          const priceSrc = html.querySelector(
            productBundle ? '.x-card-price .choose-option-price' : '.x-card-price .product-card-price'
          );
          const priceDestinations = Array.from(
            element.closest('.card-product')?.querySelectorAll('.x-card-price') || []
          ).filter((price) => !price.closest('.choose-options'));
          if (!priceDestinations.length) return;

          // TWD CUSTOMIZATION - 2026-09-03 - COLOR-SCOPED FROM PRICE
          // The card-product AJAX response now returns the correct price range for
          // the selected color (all sizes in that color), so always replace the old
          // product-wide range instead of preserving stale markup.
          if (this.currentVariant == null) return;

          if (priceSrc) {
            priceDestinations.forEach((priceDes) => {
              priceDes.classList.remove('hidden');
              priceDes.innerHTML = priceSrc.innerHTML;
            });
          }
          // END TWD CUSTOMIZATION - 2026-09-03
        },
        // START separate_color_variant 2026-07-07 - Update product title in choose-options when selecting a variant.
        _renderProductTitle(html) {
          const titleSrc = html.querySelector('.product-title');
          const chooseOptions = element.closest('.choose-options');
          const titleDes = chooseOptions?.querySelector('.product-title');

          if (chooseOptions?.dataset.separateColorVariant === 'false') {
            const baseProductTitle = chooseOptions.dataset.baseProductTitle;
            if (titleDes && baseProductTitle) titleDes.textContent = baseProductTitle;
            return;
          }

          if (titleSrc && titleDes) {
            titleDes.innerHTML = titleSrc.innerHTML;
          }
        },
        // END separate_color_variant 2026-07-07
        _renderCardProductLabels(html) {
          const labelDataSrc = html.querySelector('.x-labels-data');
          const labelDataDes = element.closest('.card-product').querySelector('.x-labels-data');

          if (labelDataSrc && labelDataDes) {
            // TWD CUSTOMIZATION - 2026-09-03: recommendation Sold out means the whole product is unavailable, not only the current exact variant.
            let labelData = labelDataSrc.getAttribute('x-labels-data');
            const cardProduct = element.closest('.card-product');
            if (cardProduct?.dataset.twdRecommendationCard === 'true') {
              try {
                const labels = JSON.parse(labelData || '[]');
                const productAvailable = cardProduct.dataset.twdProductAvailable === 'true';
                labels.forEach((label) => { label.available = productAvailable; });
                labelData = JSON.stringify(labels);
              } catch (_) {}
            }
            labelDataDes.setAttribute('x-labels-data', labelData);
            this.$nextTick(() => {
              Alpine.store('xBadges') && Alpine.store('xBadges').load(labelDataDes, () => {}, null, true);
            });
          }
        },
        _renderCardProductAvailabilityNotice(html) {
          const noticeSrc = html.getElementById('x-availability-notice');
          const noticeDes = element.closest('.card-product').querySelector('div[id*="x-availability-notice"]');

          if (noticeSrc && noticeDes) {
            noticeDes.innerHTML = noticeSrc.innerHTML;
          }
        },
        // START separate_color_variant 2026-07-07 - Keep card links pointed at the currently selected variant.
        _renderCardProductLinks() {
          if (!this.currentVariant?.id) return;

          const variantUrl = `${productUrl.split("?")[0]}?variant=${this.currentVariant.id}`;

          // TWD CHOOSE OPTION FULL DETAILS VARIANT FIX - 2026-08-03
          // The modal is outside .card-product, so update its dedicated link.
          if (chooseOption) {
            element.closest('.choose-options')?.querySelectorAll('a.view_product_detail').forEach((link) => {
              link.href = variantUrl;
            });
            return;
          }

          const cardProduct = element.closest('.card-product');
          if (!cardProduct) return;
          cardProduct.querySelectorAll('a.link-product-variant').forEach((link) => {
            link.href = variantUrl;
          });
        },
        // END separate_color_variant 2026-07-07
        // TWD CUSTOMIZATION - 2026-08-20 - COLOR CAROUSEL SYNC
        _renderCardProductCustomGallery(html, cardProduct) {
          const galleryData = html.getElementById('x-variant-custom-gallery');
          const slideList = cardProduct?.querySelector('.splide__list');
          if (!galleryData || !slideList) return;

          let images = [];
          try {
            images = JSON.parse(galleryData.textContent || '[]');
          } catch (error) {
            console.error('Unable to parse variant custom gallery data.', error);
            return;
          }

          slideList.querySelectorAll('[data-twd-custom-variant-slide="true"]').forEach((slide) => slide.remove());

          const mainImage = slideList.querySelector('.splide__slide img');
          const sizes = mainImage?.getAttribute('sizes') || '100vw';
          const mainSlide = slideList.querySelector('.splide__slide');
          const natural = mainSlide ? !mainSlide.classList.contains('h-full') && !mainSlide.classList.contains('min-h-full') : false;

          images.forEach((image, imageIndex) => {
            if (!image?.src) return;
            const slide = document.createElement('div');
            slide.setAttribute('data-twd-custom-variant-slide', 'true');
            slide.setAttribute('index', String(imageIndex + 1));
            slide.setAttribute('media', image.url || image.src);
            slide.className = `media-slide w-full splide__slide x-splide-slide z-0 transition ease-out duration-300${natural ? '' : ' h-full min-h-full'}`;

            const picture = document.createElement('picture');
            const img = document.createElement('img');
            if (image.srcset) img.setAttribute('srcset', image.srcset);
            img.setAttribute('src', image.src);
            img.setAttribute('sizes', sizes);
            img.setAttribute('alt', image.alt || '');
            img.setAttribute('loading', 'lazy');
            img.setAttribute('width', image.width || 1500);
            img.setAttribute('height', image.height || 1500);
            img.className = `w-full motion-reduce${natural ? ' aspect-auto' : ' h-full min-h-full'} object-cover`;
            picture.appendChild(img);
            slide.appendChild(picture);
            slideList.appendChild(slide);
          });

          const slider = cardProduct.querySelector('.x-splide');
          if (slider?.splide) {
            slider.splide.refresh();
            slider.splide.go(0);
          }
        },
        // END TWD CUSTOMIZATION - 2026-08-20
        _renderCardProductImage(html) {
          const variantImageData = html.getElementById('x-variant-image');
          const cardProduct = element.closest('.card-product');
          if (!variantImageData || !cardProduct) return;

          this._renderCardProductCustomGallery(html, cardProduct);

          // Once a variant image is selected, do not let the generic second
          // product media cover it when the card/Choose Options button is hovered.
          const previewImage = cardProduct.querySelector('.preview-img');
          previewImage?.classList.remove(
            'image-first-hover',
            'image-first-slide-anm',
            'lg:group-hover:opacity-0'
          );
          cardProduct.querySelectorAll('.image-second-hover, .image-first-hover-slide-anm').forEach((secondaryImage) => {
            const secondarySlide = secondaryImage.closest('.media-slide');
            if (secondarySlide) {
              secondarySlide.style.display = 'none';
            } else {
              secondaryImage.style.display = 'none';
            }
          });

          const variantImageSrc = variantImageData.dataset.imageUrl || '';
          if (variantImageSrc != '') {
            let media = cardProduct.querySelector(`[media="${variantImageSrc}"]`);
            if (media) {
              let index = media.getAttribute('index');
              let slide = cardProduct.querySelector('.x-splide');
              if (slide) {
                if (slide.splide) {
                  slide.splide.go(Number(index));
                } else {
                  document.addEventListener(`eurus:${sectionId}:splide-ready`, () => {
                    slide.splide.go(Number(index));
                  });
                }
                return;
              } 
            }
            const previewImg = cardProduct.getElementsByClassName("preview-img")[0];
            if (!previewImg) return;
            previewImg.removeAttribute("srcset");
            previewImg.setAttribute("src", variantImageSrc);
            let slide = cardProduct.querySelector('.x-splide');
            if (slide && slide.splide) {
              slide.splide.go(0);
            }
          } else {
            let slide = cardProduct.querySelector('.x-splide');
            if (slide && slide.splide) {
              slide.splide.go(0);
            }
          }
        },
        _renderLinkedProductInput() {
          const container = element.closest('.x-product-data-container');
          let desInput =
            container?.querySelector('input[name="properties[_linked_product_id][]"]') ||
            container?.querySelector('input[name="properties[_linked_product_id_qty][]"]');
          
          if (desInput) {
            if (this.currentVariant?.available) {
              desInput.value = this.currentVariant.id;
              desInput.disabled = false;
            } else {
              desInput.value = "";
              desInput.disabled = true;
            }
            desInput.classList.remove('customization-picker','validate-checkbox', 'required-picker');
          }
        },
        _renderCurrentOptionText(html) {
          const container = element.closest('.x-product-data-container');
          const desSelectedValueText = container?.querySelectorAll('.option-selected-value');
          const srcSelectedValueText = html.querySelectorAll('.option-selected-value');

          desSelectedValueText?.forEach(des => {
            const src = Array.from(srcSelectedValueText).find(
              (srcText) => srcText.dataset.optionName == des.dataset.optionName
            );
            if (src) {
              des.classList.remove('hidden');
              des.innerHTML = src.innerHTML;
              return;
            }

            // Product recommendation cards can be rendered without a matching
            // option-label fragment. Keep their label in sync from the control.
            const optionGroup = des.closest('fieldset') || des.parentElement?.closest('[data-option-name]');
            const selectedControl = optionGroup?.querySelector('input:checked, select');
            const selectedValue = selectedControl?.value;
            const valueTarget = des.querySelector('span');
            if (valueTarget && selectedValue) {
              des.classList.remove('hidden');
              valueTarget.textContent = selectedValue;
            }
          });
        },
        _renderCustomizableOptionSelectedVariant() {
          const desSelectedVariantText = element.closest('fieldset:has(.x-product-data-container)').querySelector('.selected-variant-name');
          if (desSelectedVariantText) {
            desSelectedVariantText.textContent = `: ${this.currentVariant.name}`;
          }
        },
        _renderCustomizableOptionPriceText(html) {
          const desVariantPriceText = element.closest('fieldset:has(.x-product-data-container)').querySelector(`.variant-price-${productId}`);
          const srcVariantPriceText = html.querySelector(`.variant-price-${productId}`);
          if (desVariantPriceText && srcVariantPriceText) {
            desVariantPriceText.innerHTML = `+ ${srcVariantPriceText.innerHTML}`;
          }
        },
        _getCurrentVariant(html) {
          const script = html.querySelector(
            '.x-variants-data-js script[type="application/json"][data-selected-variant]'
          ) || html.querySelector(
            '.x-variants-data-js > script[type="application/json"]'
          );

          if (!script?.textContent?.trim()) {
            this.currentVariant = null;
            return false;
          }

          try {
            this.currentVariant = JSON.parse(script.textContent);
            return true;
          } catch (error) {
            console.error('Unable to parse selected variant JSON.', error);
            this.currentVariant = null;
            return false;
          }
        },
        // START Choose Option card response variant parsing 2026-07-21
        _getChooseOptionCurrentVariant(html) {
          // Choose Option requests the card-product section. Its first direct JSON
          // child is the selected variant; its section ID differs from the modal ID.
          const script = html.querySelector(
            '.x-variants-data-js > script[type="application/json"]'
          );
          const variantJson = script?.textContent?.trim();

          if (!variantJson || variantJson === 'null') return false;

          try {
            const parsedVariant = JSON.parse(variantJson);
            if (!parsedVariant?.id) return false;

            this.currentVariant = parsedVariant;
            return true;
          } catch (error) {
            console.error('Unable to parse choose option selected variant JSON.', error);
            return false;
          }
        },
        // END Choose Option card response variant parsing 2026-07-21
        _getCurrentVariantCbl(html) {
          this.currentVariant = JSON.parse(html.querySelector(`${chooseOption ? '#choose-options-content' : '.product-card-cbl-clone'} script[type="application/json"]`)?.textContent)
        },
        // TWD CUSTOMIZATION - 2026-08-18 - COLOR NAVIGATION SYNC V2
        // Do not refresh the collection card while Choose Options is still changing.
        // Both components share the same request key, so doing that can cancel the
        // Choose Options request and leave its loader stuck. Remember the final
        // selection and apply it only when Choose Options closes.
        _rememberChooseOptionVariant() {
          if (!chooseOption || !this.currentVariant?.id) return;
          const quickViewStore = Alpine.store('xQuickView');
          if (!quickViewStore) return;
          quickViewStore.chooseOptionSelectedVariant = {
            id: this.currentVariant.id,
            options: Array.isArray(this.currentVariant.options) ? [...this.currentVariant.options] : []
          };
        },
        // END TWD CUSTOMIZATION - 2026-08-18
        updateProductCard(optionNum, target, isByob, isQuiz = false) {
          if (this._loadingResetTimer) clearTimeout(this._loadingResetTimer);
          this._scheduleLoadingReset(4000);
          this._coerceSelectionToAllowedVariant();
          this._applyClearanceVariantFilter();
          let callback = () => {};

          const isCbl = target && target !== element.dataset.url;
          const targetUrl = isCbl ? target : element.dataset.url;

          if (isCbl) {
            callback = (html) => {
              window.requestAnimationFrame(() => {
                this._getCurrentVariantCbl(html);
                this._replaceProductCardCbl(html);
                requestAnimationFrame(() => {
                  this._dispatchUpdateVariant(html);
                });
                document.dispatchEvent(new CustomEvent("eurus:variant:change", {
                  detail: {
                    variant: this.currentVariant
                  }
                }));
              });
            }
            this._renderProductCardCbl(targetUrl, callback);
            return;
          }

          if (chooseOption) {
            callback = (html) => {
              window.requestAnimationFrame(() => {
                if (!this._getChooseOptionCurrentVariant(html)) {
                  this.loadingEls = '';
                  return;
                }
                this._renderCardProductForm(html);
                this._renderCurrentOptionText(html);
                this._renderProductTitle(html);
                this._renderCardProductOption(html);
                this._renderCardProductPrice(html);
                this._renderCardProductLinks();
                // TWD CUSTOMIZATION - 2026-08-18 - COLOR NAVIGATION SYNC
                this._rememberChooseOptionVariant();
                // END TWD CUSTOMIZATION - 2026-08-18
                this._dispatchUpdateVariant(html);
                document.dispatchEvent(new CustomEvent("eurus:variant:change", {
                  detail: {
                    variant: this.currentVariant
                  }
                }));
              });
            }
          } else if (customizableChooseOption) {
            callback = (html) => {
              window.requestAnimationFrame(() => {
                this._getCurrentVariant(html);
                this._renderCardProductOption(html);
                this._renderLinkedProductInput();
                this._renderCurrentOptionText(html);
                this._renderCustomizableOptionSelectedVariant();
                this._renderCustomizableOptionPriceText(html);
                this._dispatchUpdateVariant(html);
                document.dispatchEvent(new CustomEvent("eurus:variant:change", {
                  detail: {
                    variant: this.currentVariant
                  }
                }));
              });
            }
          } else {
            callback = (html) => {
              window.requestAnimationFrame(() => {
                this._getCurrentVariant(html);
                this._renderCardProductForm(html);
                this._renderCardProductOption(html);
                this._renderCardProductPrice(html);
                this._renderCardProductLabels(html);
                this._renderCurrentOptionText(html);
                this._renderCardProductAvailabilityNotice(html);
                this._renderCardProductImage(html);
                this._renderCardProductLinks();
                this._dispatchUpdateVariant(html);
                document.dispatchEvent(new CustomEvent("eurus:variant:change", {
                  detail: {
                    variant: this.currentVariant
                  }
                }));
                
                if (isByob || isQuiz) {
                  document.dispatchEvent(new CustomEvent('eurus:product-card-update'));
                }
              });
            }
          }

          this._renderProductCard(targetUrl, optionNum, callback);
        },
        _reloadCardProduct() {
          let link = "";
          this._coerceSelectionToAllowedVariant();
          this._applyClearanceVariantFilter();
          const selectedOptionValues = this._getSelectedOptionValues()
          const selectedVariantId = chooseOption ? this._getSelectedVariantId() : null;
          let params = selectedVariantId
            ? `variant=${encodeURIComponent(selectedVariantId)}`
            : `option_values=${selectedOptionValues.join(',')}`;
          // Choose Option reads the returned card without relying on its generated
          // pagination ID. Large card instance values (for example 303) can make
          // Shopify return 404 for this section request.
          if (productBundle) {
            params = `option_values=${selectedOptionValues.join(',')}&page=${pageParam}`;
          }
          link = `${productUrl.split("?")[0]}?section_id=card-product&${params}`;
          if (this.cachedResults[link] && this.cachedResults[link] !== '') {
            this.cachedResults[link] = '';
          }

          if (chooseOption) {
            callback = (html) => {
              window.requestAnimationFrame(() => {
                if (!this._getChooseOptionCurrentVariant(html)) {
                  this.loadingEls = '';
                  return;
                }
                this._renderCardProductForm(html);
                this._renderCurrentOptionText(html);
                this._renderProductTitle(html);
                this._renderCardProductOption(html);
                this._renderCardProductPrice(html);
                this._renderCardProductLinks();
                // TWD CUSTOMIZATION - 2026-08-18 - COLOR NAVIGATION SYNC
                this._rememberChooseOptionVariant();
                // END TWD CUSTOMIZATION - 2026-08-18
                this._dispatchUpdateVariant(html);
              });
            }
          } else if (customizableChooseOption) {
            callback = (html) => {
              window.requestAnimationFrame(() => {
                this._getCurrentVariant(html);
                this._renderCardProductOption(html);
                this._renderLinkedProductInput();
                this._renderCurrentOptionText(html);
                this._renderCustomizableOptionSelectedVariant();
                this._renderCustomizableOptionPriceText(html);
                this._dispatchUpdateVariant(html);
              });
            }
          } else {
            callback = (html) => {
              window.requestAnimationFrame(() => {
                this._getCurrentVariant(html);
                this._renderCardProductForm(html);
                this._renderCardProductOption(html);
                this._renderCardProductPrice(html);
                this._renderCardProductLabels(html);
                this._renderCardProductAvailabilityNotice(html);
                this._renderCardProductImage(html);
                this._renderCardProductLinks();
                this._dispatchUpdateVariant(html);
              });
            }
          }

          this._renderProductCard(productUrl, -1, callback);
        },
        _renderProductCard(url, optionNum, callback) {
          let link = "";
          const selectedOptionValues = this._getSelectedOptionValues();
          if (optionNum !== -1) {
            if (selectedOptionValues.length < Number(optionNum)) {
              window.requestAnimationFrame(() => {
                setTimeout(() => { this.loadingEls = ''; }, 100);
              });

              return
            };
          }
          if (selectedOptionValues.length === 0) {
            this._scheduleLoadingReset(100);
            return;
          }
          const selectedVariantId = chooseOption ? this._getSelectedVariantId() : null;
          let params = selectedVariantId
            ? `variant=${encodeURIComponent(selectedVariantId)}`
            : `option_values=${selectedOptionValues.join(',')}`;
          // Do not pass the Choose Option card-instance token as a pagination page.
          if (productBundle) {
            params = `option_values=${selectedOptionValues.join(',')}&page=${pageParam}`;
          }
          link = `${url.split("?")[0]}?section_id=card-product&${params}`;
          Alpine.store('xHelper').cancelRequest(`eurus:product_card_request:${productId}`);
          if (this.cachedResults[link] && this.cachedResults[link] !== '') {
            const html = this.cachedResults[link];
            window.requestAnimationFrame(() => {
              callback(html);
              this._scheduleLoadingReset(250);
            });
          } else {
            const controller = new AbortController();
            Alpine.store('xHelper').requestControllers.set(`eurus:product_card_request:${productId}`, controller);
            fetch(link, { signal: controller.signal })
              .then((response) => {
                if (!response.ok) {
                  throw new Error(`Product card request failed (${response.status}): ${link}`);
                }
                return response.text();
              })
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                window.requestAnimationFrame(() => {
                  callback(html);
                  this._scheduleLoadingReset(250);
                });
                this.cachedResults[link] = html;
              }).catch(err => {
                if (err.name !== 'AbortError') {
                  console.error(err);
                }
                this._scheduleLoadingReset(100);
                window.requestAnimationFrame(() => {
                  setTimeout(() => { this.loadingEls = ''; }, 100);
                })
              })
          }
        },
        _renderProductCardCbl(url, callback) {
          let link = `${url}?section_id=${handleSectionId}&page=${pageParam}`;

          Alpine.store('xHelper').cancelRequest(`eurus:product_card_request:${productId}`);
          if (this.cachedResults[link] && this.cachedResults[link] !== '') {
            const html = this.cachedResults[link];
            window.requestAnimationFrame(() => {
              callback(html);
              this._scheduleLoadingReset(250);
            });
          } else {
            const controller = new AbortController();
            Alpine.store('xHelper').requestControllers.set(`eurus:product_card_request:${productId}`, controller);
            fetch(link, { signal: controller.signal })
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                window.requestAnimationFrame(() => {
                  callback(html);
                  this._scheduleLoadingReset(250);
                });
                this.cachedResults[link] = html;
              }).catch(err => {
                if (err.name !== 'AbortError') {
                  console.error(err);
                }
                this._scheduleLoadingReset(100);
              })
          }
        },
        _replaceProductCardCbl(html) {
          let src, des;
          if (chooseOption) {
            src = html.querySelector('#choose-options-content .choose-options');
            des = element.closest(`.choose-options`);
          } else {
            src = html.getElementById(`card-product-clone-${handleSectionId}`);
            des = element.closest('.card-product');
          }

          if (src && des) {
            des.innerHTML = src.innerHTML;
          }
        },
        _getSelectedOptionValues() {
          // START Choose Option live dropdown values 2026-07-21
          // The HTML `[selected]` attribute can remain on the old size after a user changes
          // a select. Choose Option must read `selectedOptions` so the request contains the
          // size currently visible in the dropdown. Other card flows keep the original logic.
          if (chooseOption) {
            const values = [];

            element.querySelectorAll('select, fieldset').forEach((control) => {
              const selected = control.tagName === 'SELECT'
                ? control.selectedOptions?.[0]
                : control.querySelector('input:checked');
              const optionValueId = selected?.dataset?.optionValueId;
              if (optionValueId) values.push(optionValueId);
            });

            return values;
          }

          return Array.from(element.querySelectorAll('select option[selected][value], fieldset input:checked')).map(
            (e) => e.dataset.optionValueId
          );
          // END Choose Option live dropdown values 2026-07-21
        },
        _getSelectedVariantId() {
          const variantsJson = element.querySelector(
            'script[type="application/json"][data-product-variants]'
          )?.textContent?.trim();
          if (!variantsJson) return null;

          const selectedValues = [];
          element.querySelectorAll('select, fieldset').forEach((control) => {
            const selected = control.tagName === 'SELECT'
              ? control.selectedOptions?.[0]
              : control.querySelector('input:checked');
            if (selected) selectedValues.push(selected.value);
          });

          try {
            const variants = JSON.parse(variantsJson);
            const variant = variants.find((candidate) =>
              candidate.options?.length === selectedValues.length
              && candidate.options.every((value, index) => value === selectedValues[index])
            );
            return variant?.id || null;
          } catch (error) {
            console.error('Unable to resolve the selected Choose Option variant.', error);
            return null;
          }
        }
      }))
    });
  });
}
